import { isTrackEmpty } from './isTrackEmpty';

export const isStreamInactive: (stream: MediaStream) => boolean = (stream) => {
  if (!stream.active) {
    return true;
  }

  return stream.getTracks().every(isTrackEmpty);
};
